import React, { useEffect, useRef, useState } from "react";
import {
  getCompanyRequests,
  getCompanyRequest,
  setCompanyRequest,
  deleteCompanyRequest,
  getCompanyRequestCount,
  getOffices,
  getServices,
} from "../../services/address-book";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";
import { getCounties } from "../../services/dictionary";
import XLSX from "xlsx";
import { getMyPositions, getPositions } from "../../services/position";
import moment from "moment/moment";
import { saveAs } from "file-saver";

CompanyRequests.propTypes = {};

function CompanyRequests(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);
  const [filter, setFilter] = useState("");
  const [listFilter, setListFilter] = useState({});

  const permissions = usePermission("dictionary");

  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa
  const [offices, setOffices] = useState([]);
  useEffect(() => {
    getOffices()
      .then((response) => {
        setOffices(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  const [services, setServices] = useState([]);
  useEffect(() => {
    getServices()
      .then((response) => {
        setServices(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  const [counties, setCounties] = useState([]);
  useEffect(() => {
    getCounties()
      .then((response) => {
        setCounties(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const types = [
    {
      id: 1,
      value: 1,
      name: "telefon",
    },
    {
      id: 2,
      value: 2,
      name: "dokumentum",
    },
    {
      id: 10,
      value: 10,
      name: "MD",
    },
    {
      id: 20,
      value: 20,
      name: "HC",
    },
  ];

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "type",
      fieldType: "select",
      headerName: "Típus",
      valueGetter: (params) => {
        let v = `ismeretlen (${params.row?.type})`;
        if (types.length) {
          const type = types.find((item) => item.id === params.row?.type);
          if (type) {
            v = type.name;
          }
        }
        return v;
      },
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Név",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "companyName",
      fieldType: "text",
      headerName: "Cégnév",
    },
    {
      field: "email",
      fieldType: "text",
      headerName: "E-mail",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "phone",
      fieldType: "text",
      headerName: "Telefonszám",
    },
    {
      field: "officeId",
      fieldType: "select",
      headerName: "Iroda",
      hide: true,
      valueGetter: (params) => {
        let v = `ismeretlen (${params.row?.officeId})`;
        if (offices.length) {
          const office = offices.find(
            (item) => item.id === params.row?.officeId
          );
          if (office) {
            v = office.name;
          }
        }
        return v;
      },
    },
    {
      field: "serviceId",
      fieldType: "select",
      headerName: "Szolgáltatás",
      valueGetter: (params) => {
        let v = `ismeretlen (${params.row?.serviceId})`;
        if (services.length) {
          const service = services.find(
            (item) => item.id === params.row?.serviceId
          );
          if (service) {
            v = service.name;
          }
        }
        return v;
      },
    },
    {
      field: "comment",
      fieldType: "text",
      headerName: "Megjegyzés",
    },
    {
      field: "document",
      fieldType: "hidden",
      hide: true,
    },
    {
      field: "documentId",
      fieldType: "",
      headerName: "Dokumentum",
      renderCell: (params) => {
        const doc = params?.row?.document;
        if (!doc) return "-";
        if (doc.accessHash) {
          const url = `${process.env.REACT_APP_API_URL}/public/document/${doc.id}/${doc.accessHash}`;
          return (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {doc.filename || "Csatolmány"}
            </a>
          );
        }
        return doc.filename || "-";
      },
      renderNonInput: ({ values }) => {
        const doc = values?.document;
        if (!doc) return "-";
        if (doc.accessHash) {
          const url = `${process.env.REACT_APP_API_URL}/public/document/${doc.id}/${doc.accessHash}`;
          return (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {doc.filename || "Csatolmány"}
            </a>
          );
        }
        return doc.filename || "-";
      },
      valueGetter: (params, formParams) => {
        const row = formParams?.row || params?.row;
        const doc = row?.document;
        if (!doc) return "-";
        return doc.filename || "-";
      },
    },
    {
      field: "userId",
      fieldType: "",
      headerName: "Felhasználó ID",
      hide: true,
      width: 100,
    },
    {
      field: "createTime",
      fieldType: "",
      headerName: "Dátum",
      width: 100,
      valueGetter: (params) => {
        if (params.row?.createTime) {
          return moment(params.row.createTime).format("YYYY-MM-DD HH:mm:ss");
        }
        return "";
      },
    },
  ];

  const exportToExcel = (data, fileName) => {
    const XLSX = require("xlsx");
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };

  const handleExportToExcel = (apiRef) => {
    const fn = getCompanyRequests;
    if (!listFilter.createTime) {
      listFilter.createTime = { gte: moment().subtract(3, "months").format() };
    }
    fn(listFilter, [], 100000, 0).then((response) => {
      const toExport = response.data.map((item) => {
        const type = types.find((type) => type.id === item.type);
        const row = {
          id: item.id,
          típus: type?.name || "ismeretlen",
          név: item.name,
          cég: item.companyName,
          email: item.email,
          telefon: item.phone,
          iroda: item.office?.name || item.county?.name || "",
          szolgáltatás: item.service?.name || "",
          megjegyzés: item.comment,
          dokumentum: item.document?.accessHash
            ? `${process.env.REACT_APP_API_URL}/public/document/${item.document.id}/${item.document.accessHash}`
            : item.document?.originalFilename
            ? `${process.env.REACT_APP_API_URL}${item.document.originalFilename}`
            : "",
          dátum: `'${
            item.createTime
              ? moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")
              : ""
          }`,
        };
        return row;
      });
      exportToExcel(toExport, "arajanlat-keresek");
    });
  };

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Árajánlat kérés",
    url: "/address-books/company-requests",
    item: "árajánlat kérés",
    exportToExcel: handleExportToExcel,
  };

  const refTimeout = useRef(null);

  const handleQuickfilter = (value) => {
    if (refTimeout.current) {
      clearTimeout(refTimeout.current);
      refTimeout.current = null;
    }
    refTimeout.current = setTimeout(() => {
      setFilter(value);
    }, 100);
  };

  useEffect(() => {
    const where = {};
    const matchInterval = filter.match(
      /^(20[0-9]{2}[-./][0-2][0-9][-./][0-3][0-9][.]?)[\s]?-[\s]?(20[0-9]{2}[-./][0-2][0-9][-./][0-3][0-9][.]?)$/
    );
    const matchDate = filter.match(
      /^(20[0-9]{2}[-./][0-2][0-9][-./][0-3][0-9][.]?)$/
    );
    if (matchInterval) {
      const from = moment(matchInterval[1]).format("YYYY-MM-DD HH:mm:ss");
      const to = moment(matchInterval[2]).format("YYYY-MM-DD HH:mm:ss");
      where.createTime = { between: [from, to] };
    } else if (matchDate) {
      const filterDate = moment(matchDate[1]).format("YYYY-MM-DD");
      where.createTime = {
        between: [`${filterDate} 00:00:00`, `${filterDate} 23:59:59`],
      };
    } else if (filter.toString() !== "") {
      const like = `%${filter}%`;
      where.or = [
        { name: { like: like } },
        { companyName: { like: like } },
        { email: { like: like } },
        { comment: { like: like } },
      ];
    }
    setListFilter(where);
  }, [filter]);

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getCompanyRequest}
          setFunc={setCompanyRequest}
          types={types}
          offices={offices}
          services={services}
          counties={counties}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getCompanyRequests}
          getCountFunc={getCompanyRequestCount}
          deleteFunc={deleteCompanyRequest}
          quickfilterFunc={handleQuickfilter}
          getParams={listFilter}
          columns={columns}
          types={types}
          offices={offices}
          services={services}
          counties={counties}
        ></Lists>
      )}
    </>
  );
}

export default CompanyRequests;
